module.exports = __webpack_public_path__ + "static/img/funny_08.7c26cfa0.jpg";